import React from "react";
import "./Grid.css";

const Grid = ({ gridSize, children }) => (
  <div className="grid" style={{ gridTemplateColumns: `repeat(${gridSize || 3}, 1fr)` }}>
    {children}
  </div>
);

export default Grid;
